import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectionInvertIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path d="M2 2H10V6H6V10H2V2Z" fill={color} />
      <path d="M6 10H14V14H6V10Z" fill={color} />
      <path d="M10 6H14V10H10V6Z" fill={color} />
      <rect x="6" y="6" width="4" height="4" stroke={color} strokeWidth="1" fill="none" />
    </BaseIcon>
  ),
);

SelectionInvertIcon.displayName = 'SelectionInvertIcon';
